import React, {useMemo} from "react";
import {formatDateTime} from "@/utils/DateUtils";

type Props = {
    date: string,
};

const DateTimeFormatter = ({date}: Props) => {
    const formattedDate: string = useMemo(
        () => formatDateTime(date),
        [date]);
    return (
        <div className={"w-fit inline"}>
            {formattedDate}
        </div>
    );
};

export default DateTimeFormatter;